import { CREHANA_BASE_URL_PRD, CREHANA_HOSTNAME_PRD } from '@crehana/constants';

import { Link, RouteWrapper, Subtitle } from '@/views/CrehanaLegal/components';

const TermsAndConditions = () => (
  <RouteWrapper>
    <section>
      <p>
        A LEITURA E ACEITE DESTES <strong>TERMOS E CONDIÇÕES</strong> É CONDIÇÃO
        PRECEDENTE PARA ACESSO E USO DA PLATAFORMA CREHANA. DE IGUAL MODO, A
        LEITURA E ACEITE DE NOSSAS{' '}
        <strong>
          POLÍTICAS DE PRIVACIDADE (disponíveis em [{CREHANA_HOSTNAME_PRD}])
        </strong>
        , ONDE DETALHAMOS NOSSAS PRÁTICAS DE TRATAMENTO DE DADOS PESSOAIS, É
        CONDIÇÃO PRECEDENTE PARA ACESSO E USO DA PLATAFORMA CREHANA.
      </p>
      <p>
        O ACESSO E/OU USO DO SITE POR QUALQUER CLIENTE E/OU USUÁRIO IMPLICA A
        ACEITAÇÃO INTEGRAL DE A TODAS AS DISPOSIÇÕES CONTIDAS NESTES TERMOS E DO
        RESPECTIVO CONTRATO DE SERVIÇO ASSINADO PELO CLIENTE, CONFORME
        APLICÁVEL.
      </p>
      <p>
        ESSES TERMOS E CONDIÇÕES REGEM A RELAÇÃO ENTRE CREHANA E CLIENTES EM
        RELAÇÃO À PRESTAÇÃO DE SERVIÇOS E A RELAÇÃO ENTRE CREHANA E CLIENTES
        E/OU USUÁRIOS COM RELAÇÃO À LICENÇA DE ACESSO AO CONTEÚDO DISPONÍVEL NA
        PLATAFORMA. AO ACEITAR ESTES <strong>TERMOS E CONDIÇÕES</strong>, O
        CLIENTE DECLARA QUE É UMA EMPRESA DEVIDAMENTE CONSTITUÍDA E QUE,
        JUNTAMENTE DE SEU REPRESENTANTE LEGAL, POSSUEM A CAPACIDADE LEGAL
        NECESSÁRIA PARA ESTAR VINCULADO A ESSES{' '}
        <strong>TERMOS E CONDIÇÕES</strong>, BEM COMO O USUÁRIO DECLARA POSSUIR
        A CAPACIDADE JURÍDICA NECESSÁRIA PARA TAMBÉM ACEITAR OS{' '}
        <strong>TERMOS E CONDIÇÕES</strong>.
      </p>
      <p>
        O CLIENTE ADEMAIS COMPROMETE-SE A CUMPRIR E FAZER COM QUE OS USUÁRIOS
        CUMPRAM ESTES TERMOS E CONDIÇÕES, BEM COMO COM OS TERMOS E CONDIÇÕES
        GERAIS DE USO DA PLATAFORMA CREHANA QUE SÃO PUBLICADOS NO SEGUINTE
        ENDEREÇO: <Link href="www.crehana.com" />.
      </p>
    </section>
    <section>
      <Subtitle>1. Definições</Subtitle>
      <p>
        Sem prejuízo dos termos definidos no decorrer deste documento, os termos
        aqui utilizados com a primeira letra maiúscula e que não sejam definidos
        de forma diferente, terão o significado que lhes é atribuído abaixo,
        podendo ser usados no masculino, feminino ou neutro, bem como singular
        ou plural, indistintamente e dependendo do contexto:
      </p>
      <p>
        a. <strong>Afiliado.</strong> Significa que qualquer entidade que
        controle diretamente, seja controlada ou esteja sob o controle comum de
        outra entidade.
      </p>
      <p>
        b. <strong>Ativação.</strong> Significa o colocar em funcionamento e
        realizar a validação de tudo o que for necessário para a prestação
        adequada dos Serviços, o que inclui, mas não se limita a, as
        implementações, integrações, revisão da documentação e outras ações a
        serem realizadas pela Crehana.
      </p>
      <p>
        c. <strong>Cliente.</strong> Significa a parte que celebrou o Contrato
        de Serviço com a Crehana ou que acessou os Serviços por qualquer outra
        forma ou meio.
      </p>
      <p>
        d. <strong>Consultoria de Ativação e Onboarding.</strong> Significa o
        valor que o Cliente pagará anualmente à Crehana, no início dos Serviços
        e posteriormente em cada aniversário, para que Crehana realize a
        ativação, adaptações, implementações e melhorias no acompanhamento do
        Cliente. Se ativo e aplicável, o pagamento da Consultoria de Ativação e
        Onboarding será somado ao custo de emissão da primeira fatura e,
        posteriormente, será adicionado à fatura de cada aniversário.
      </p>
      <p>
        e. <strong>Conteúdo.</strong> Significa os produtos de educação online
        oferecidos através da Plataforma Crehana.
      </p>
      <p>
        f. <strong>Contraprestação.</strong> Significa o valor a ser pago pelo
        Cliente à Crehana para prestação dos Serviços e acesso ao Conteúdo na
        Plataforma e/ou a Licença de Conteúdo conforme estabelecido no Contrato
        de Serviço sob o título: Custo Anual.
      </p>
      <p>
        g. <strong>Contrato de Serviço.</strong> Significa o Contrato Comercial
        celebrado entre as Partes e/ou Proposta Comercial aceita pelo Cliente,
        incluindo todas as ordens que são processadas por meios eletrônicos, que
        fornecem, pelo menos, os seguintes itens: (i) a Contraprestação a ser
        abrangida pelo Cliente para a prestação dos Serviços; (ii) o Termo dos
        Serviços; (iii) o número de Usuários autorizados a acessar a Plataforma
        e seus Conteúdos; (iv) informações de faturamento e pagamento; e (v)
        qualquer outra particularidade aplicável à prestação dos Serviços ao
        Cliente.
      </p>
      <p>
        h. <strong>Crehana.</strong> Significa marca registrada do grupo de
        empresas localizadas em:
        <ul>
          <li>
            (i) Crehana Education México, S. de R.L. de C.V., com sede na Av.
            Paseo de la Reforma 296, 25º andar, escritório 118, bairro Benito
            Juárez, Delegação Cuauhtémoc, Cidade do México, México, C.P. 06600.
          </li>
          <li>
            (ii) Crehana Educação Peru S.A.C., com sede na Rua Coronel Andrés
            Reyes nº 338, Urbanização Jardin Int. 02-1, Distrito de San Isidro,
            Lima, Peru.
          </li>
          <li>
            (iii) Crehana Educação Colômbia S.A.S., com sede na Calle 96 # 12 -
            31 Piso 3, em Bogotá D.C.
          </li>
          <li>
            (iv) Crehana Educação Chile Capacitaciones SpA, com sede na Avenida
            Providencia N° 1650, Oficina 611, comuna de Providencia, Ciudad de
            Santiago, Región Metropolitana.
          </li>
          <li>
            (v) Crehana Education Inc., com sede na 2035 Sunset Lake Road, Suite
            B-2, cidade de Newark, condado de New Castle, 19702, Delaware, EUA.
          </li>
          <li>
            (vi) Crehana Education Brasil Ltda, com sede na Cidade de São Paulo,
            Estado de São Paulo, na Avenida Paulista, nº 1.471, conjunto 511,
            Bela Vista, CEP 01311-927, Brasil.
          </li>
          <li>
            (vii) Acsendo S.A.S, Colômbia, Rua 96 #12-31, Bogotá, Colombia.
          </li>
        </ul>
      </p>
      <p>
        i. <strong>Dados Pessoais.</strong> Significa toda informação ou
        conjunto de informações que identifiquem ou possam identificar uma
        pessoa natural, em conformidade com o previsto na legislação em vigor,
        tratados de acordo com o disposto na Política de Privacidade da Crehana,
        disponível em {CREHANA_BASE_URL_PRD} e aceita pelos Clientes e Usuários
        como condição necessária à utilização da Plataforma.
      </p>
      <p>
        j. <strong>Licença.</strong> Significa o direito não exclusivo de acesso
        aos Conteúdos de propriedade da Crehana que são disponibilizados aos
        Clientes por prazo determinado de acordo com os termos do Contrato de
        Serviço.
      </p>
      <p>
        k. <strong>Partes.</strong> Significa o Cliente e Crehana.
      </p>
      <p>
        l. <strong>Plataforma.</strong> Significa que o site{' '}
        {CREHANA_BASE_URL_PRD}/br, a plataforma virtual e/ou outras mídias
        digitais, como aplicativos para dispositivos smartphones com tecnologia
        IOS ou Android, tablets, SmartTv, entre outros, de propriedade da
        Crehana, dentro do qual os Clientes e Usuários cadastrem-se para obter o
        Serviço.
      </p>
      <p>
        m. <strong>Serviços.</strong> Significa qualquer um dos Serviços que são
        adquiridos pelo Cliente de acordo com o Contrato de Serviço, descritos
        na Seção 2 destes Termos e Condições.
      </p>
      <p>
        n. <strong>Termos e Condições.</strong> Significa estes termos gerais e
        condições de contratação de serviços de Crehana, modificados de tempos
        em tempos, bem como aqueles aos quais a referência é feita na Seção 4.,
        abaixo.
      </p>
      <p>
        o. <strong>Usuários.</strong> Significa usuários identificados pelo
        Cliente com acesso a Plataforma e acesso aos Serviços correspondentes de
        acordo com este Contrato de Serviço.
      </p>
    </section>
    <section>
      <Subtitle>2. Escopo de Serviços</Subtitle>
      <p>
        A Crehana compromete-se a fornecer ao Cliente e Usuários serviços
        educacionais em diversas áreas do conhecimento em sua Plataforma, por
        meio da concessão de uma Licença, ou mediante desenvolvimento de cursos
        ou programas on demand, mediante acordo prévio estabelecido entre
        Crehana e Cliente no Contrato de Serviço, que possam ser modificados ou
        atualizados de acordo com as necessidades do Cliente e
        discricionariedade da Crehana, de tempos em tempos.
      </p>
      <p>
        Clientes e Usuários reconhecem que a Crehana poderá, a seu exclusivo
        critério e a qualquer tempo: (i) alterar ou remover funcionalidades da
        Plataforma que não estejam alinhadas com seus interesses, bem como
        adicionar novas funcionalidades que tragam benefícios à utilização da
        Plataforma, sem qualquer comunicação prévia ao Cliente e/ou Usuários;
        (ii) descontinuar de forma definitiva ou temporária os Serviços
        disponibilizados por meio da Plataforma, mediante comunicação prévia ao
        Cliente e aos Usuários; e/ou (iii) suspender e/ou bloquear
        preventivamente o acesso do Cliente e/ou dos usuários ao Serviços e/ou a
        Plataforma, pelo período estabelecido na regulamentação aplicável, em
        caso de mera suspeita de fraude, obtenção de benefício ou vantagem de
        forma ilícita, ou pelo não cumprimento de quaisquer condições previstas
        no Contrato de Serviço, nos presentes Termos e Condições e demais
        documentos conexos à relação entre as partes e/ou na legislação
        aplicável. Os Clientes e Usuários reconhecem que, nesses casos, não
        estarão sujeitos ao recebimento de qualquer indenização a ser paga pela
        Crehana, e que a Crehana poderá promover quaisquer medidas necessárias
        para obter e resguardar seus direitos e interesses neste sentido.
      </p>
    </section>
    <section>
      <Subtitle>
        3. Concessão de Licença e Disponibilidade dos Serviços
      </Subtitle>
      <p>
        Sujeito ao cumprimento dos Termos e Condições, Crehana fornecerá em
        favor do Cliente e/ou Usuário uma Licença temporária, revogável, não
        exclusiva, intransferível e não sublicenciável, para acesso do Cliente
        e/ou Usuários à Plataforma e Conteúdos da Crehana. A Concessão da
        Licença ao Cliente também estará condicionada ao adimplemento da
        Contraprestação para acesso ao Conteúdo Crehana.
      </p>
      <p>
        O Cliente e/ou Usuário reconhecem que a Plataforma está sujeita a
        indisponibilidades decorrentes de problemas técnicos ou atualizações e
        suporte da Plataforma e que tais indisponibilidades não impactarão a
        Licença, tampouco concederá ao Cliente e/ou Usuário qualquer direito de
        indenização ou reparação de quaisquer danos supostamente incorridos em
        razão de indisponibilidade. Independente do motivo, a Crehana fará seus
        melhores esforços para restaurar a perfeita disponibilidade e capacidade
        de utilização da Plataforma no menor tempo possível.
      </p>
    </section>
    <section>
      <Subtitle>4. Contraprestação</Subtitle>
      <p>
        Pelos Serviços prestados e pela concessão da Licença conforme
        apropriado, o Cliente pagará à Crehana o valor total estabelecido no
        Contrato de Serviço, observados os prazos estabelecidos, sendo certo que
        o não pagamento da Contraprestação poderá gerar a revogação da Licença,
        conforme indicado anteriormente.
      </p>
    </section>
    <section>
      <Subtitle>5. Propriedade Industrial e Direitos Autorais</Subtitle>
      <p>
        O conteúdo de nossa plataforma é protegido pelas regulamentações de
        direitos autorais em vigor nos Estados Unidos da América, bem como pelas
        leis locais de cada uma de nossas subsidiárias:
        <ul>
          <li>Chile: Lei 17336, Lei de Propriedade Intelectual.</li>
          <li>
            Colômbia: Lei da Propriedade Intelectual (Lei 23 de 1982),
            parcialmente modificada pela Lei 1915 de 2018, e os tratados
            internacionais dos quais a Colômbia participa
          </li>
          <li>
            México: Lei Federal de Proteção da Propriedade Industrial e a Lei
            Federal de Direitos Autorais e os tratados internacionais
            correspondentes.
          </li>
          <li>
            Peru: Lei de Direitos Autorais (Decreto Legislativo 822), suas
            alterações e os tratados internacionais correspondentes.
          </li>
          <li>
            Brasil: Lei de Direitos Autorais (Lei nº 9.610/98) e Lei de
            Propriedade Intelectual (Lei nº 9.279/96), suas alterações e os
            tratados internacionais correspondentes.
          </li>
        </ul>
      </p>
      <p>
        Crehana, suas subsidiárias, afiliadas e/ou licenciadores são os
        proprietários dos direitos industriais e intelectuais relacionados e/ou
        derivados desta Plataforma.
      </p>
      <p>
        Crehana, seus logotipos e todo o material que aparece na Plataforma,
        programas, documentos ou não, são marcas comerciais, nomes de domínio,
        nomes comerciais e obras artísticas, de propriedade exclusiva da
        Crehana, suas subsidiárias, afiliadas e/ou licenciadores e são
        protegidos por tratados internacionais e leis aplicáveis de propriedade
        industrial e intelectual e de direito autoral.
      </p>
      <p>
        Direitos autorais no conteúdo, organização, compilação, informações,
        logótipos, fotografias, imagens, programas, aplicativos e, em geral,
        qualquer informação contida ou publicada em a plataforma, programas ou
        outros, são devidamente protegidos em favor da Crehana, de suas
        subsidiárias, afiliadas e/ou licenciadores de acordo com a legislação
        aplicável de propriedade intelectual e industrial, e de direito autoral.
      </p>
      <p>
        O Cliente e os Usuários estão expressamente proibidos de modificar,
        alterar ou excluir, total ou parcialmente, os avisos, marcas comerciais,
        nomes comerciais, sinais, anúncios, logotipos ou, em geral, qualquer
        indicação que se refere a qualquer indicação que se refere à propriedade
        das informações contidas na plataforma indicada. Da mesma forma, o
        Cliente e os Usuários comprometem-se a não exibir, distribuir,
        licenciar, executar, publicar, reproduzir, duplicar, copiar, criar obras
        derivadas, modificar, vender, revender, explorar, transferir ou carregar
        para quaisquer fins, qualquer parte do Serviço, uso do Serviço ou acesso
        ao Conteúdo.
      </p>
      <p>
        Qualquer exploração total ou parcial dos direitos de propriedade
        industrial e intelectual, ou ainda direito autoral relacionados e/ou
        derivados do Serviço exigirá o consentimento prévio por escrito de
        Crehana. Qualquer eventual autorização de uso dos direitos de
        propriedade industrial e intelectual ou direitos autorais pela Crehana,
        suas subsidiárias, afiliadas e/ou licenciadores ao Cliente e/ou Usuário
        deverão ser entendidos como mera autorização individual de uso, que não
        transfere, cede ou licencia tais direitos, de qualquer maneira e em
        qualquer hipótese.
      </p>
      <p>
        Quaisquer direitos de propriedade intelectual autorizados por Crehana
        para fins editoriais devem conter a seguinte legenda:
      </p>
      <div className="pl-24">
        <p className="text-right">
          Todos os direitos reservados, © Crehana Education Colombia S.A.S., com
          sede na Calle 96 # 12 - 31 Piso 3, em Bogotá D.C.
        </p>
        <p className="text-right">
          Todos os direitos reservados, © Crehana Educação Chile Capacitaciones
          S.P.A., com sede na Av. Providencia 1650, escritório 611, Santiago,
          Chile.
        </p>
        <p className="text-right">
          Todos os direitos reservados, © Crehana Education Inc., com sede na
          2035 Sunset Lake Road, Suite B-2, cidade de Newark, condado de New
          Castle, 19702, Delaware, EUA.
        </p>
        <p className="text-right">
          Todos os direitos reservados, © Crehana Education México, S. de R.L.
          de C.V., com sede na Av. Paseo de la Reforma 296, 25º andar,
          escritório 118, bairro Benito Juárez, Delegação Cuauhtémoc, Cidade do
          México, México, C.P. 06600.
        </p>
        <p className="text-right">
          Todos os direitos reservados, © Crehana Educação Perú S.A.C., com sede
          na Rua Coronel Andrés Reyes nº 338, Urbanização Jardin Int. 02-1,
          Distrito de San Isidro, Lima, Peru.
        </p>
        <p className="text-right">
          Todos os direitos reservados, © Crehana Education Brasil Ltda, com
          sede na Cidade de São Paulo, Estado de São Paulo, na Avenida Paulista,
          nº 1.471, conjunto 511, Bela Vista, CEP 01311-927, Brasil.”
        </p>
      </div>
      <p>
        O Cliente e os Usuários comprometem-se, irrevogavelmente, a não exibir,
        distribuir, licenciar, executar, publicar, reproduzir, duplicar, copiar,
        criar obras derivadas, modificar, vender, revender, explorar,
        compartilhar seu acesso e uso para diferentes usuários, transferir ou
        carregar, independente da finalidade e/ou propósito, qualquer parte do
        Serviço, uso do Serviço e/ou da Plataforma, acesso a Plataforma e ao
        Conteúdo.
      </p>
    </section>
    <section>
      <Subtitle>6. Responsabilidade</Subtitle>
      <p>
        O Cliente e Usuários obrigam-se, em caráter irrevogável e irretratável,
        a indenizar, defender e manter a Crehana, seus acionistas, sócios,
        afiliadas, empregados, administradores, representantes, sucessores e
        cessionários indenes e a salvo de toda e qualquer perda, dano direto ou
        indireto, indenização, demanda, ação, processo judicial e/ou
        administrativo, penalidade, multa, prejuízo, custo e/ou despesas, juros
        e taxas (inclusive custas de preparação e investigação, honorários
        advocatícios, de consultores ou outros peritos e ônus de sucumbência)
        que venha a ser sofrer e/ou desembolsar, em decorrência de:
      </p>
      <p>
        a. Qualquer ato, fato ou omissão imputável ao Cliente, seus
        administradores, acionistas, sócios, empregados, afiliadas, sucessores,
        prepostos e representantes, a qualquer título, que gere prejuízo à
        Crehana;
      </p>
      <p>
        b. Não cumprimento, parcial ou total, de qualquer obrigação prevista
        neste Termos e Condições, no Contrato de Serviços, Política de
        Privacidade da Crehana e/ou na legislação aplicável;
      </p>
      <p>
        c. Falha em observar os requisitos de integração e operação da
        Plataforma, bem como a inobservância dos procedimentos de utilização das
        tecnologias e propriedades da Crehana; e/ou
      </p>
      <p>d. Prática de ato manifestamente ilegal ou ilícito.</p>
      <p>
        Por sua vez, a Crehana não assume nenhuma responsabilidade de indenizar
        ou defender, substituir, acompanhar ou mesmo de peticionar a exclusão do
        Cliente e/ou Usuários à lide, referente a qualquer demanda, litígio,
        reclamação, ou ação, de qualquer que seja sua natureza, no contexto
        destes Termos e Condições.
      </p>
      <p>
        Caso receberem qualquer reclamação, notificação, multa, advertência, ou
        intimação de quaisquer temas que possam afetar a Crehana, o Cliente e/ou
        Usuário deverão envidar seus melhores esforços para notificar a Crehana
        de tal fato por escrito, no prazo de 5 (cinco) dias úteis contados da
        tomada de conhecimento da situação específica.
      </p>
    </section>
    <section>
      <Subtitle>7. Publicidade e Uso de Marca</Subtitle>
      <p>
        O Cliente confere à Crehana e suas afiliadas e subsidiárias o direito de
        exploração de seu nome comercial e marcas registradas para os fins
        exclusivos de publicidade dentro dos canais de comunicação da Crehana e
        nos limites do Contrato de Serviço. Tal licença de uso é concedida de
        maneira gratuita e não onerosa e não sublicenciável .
      </p>
      <p>
        Essas comunicações terão como objetivo destacar o trabalho conjunto de
        Crehana e do Cliente com o desenvolvimento de talentos através dos
        canais de comunicação da Crehana, inclusive sem limitar redes sociais,
        blogs e sites.
      </p>
    </section>
    <section>
      <Subtitle>8. Não exclusividade</Subtitle>
      <p>
        A Licença e prestação dos Serviços Crehana ao Cliente e Usuários não
        concedem qualquer direito exclusivo ao Conteúdo ou Serviços, de modo que
        a Crehana pode autorizar o uso do Conteúdo e fornecer os Serviços a
        terceiros, desde que não represente uma violação de suas obrigações de
        Confidencialidade nos termos destes Termos e Condições e do Contrato de
        Pretação de Serviços, conforme aplicável.
      </p>
    </section>
    <section>
      <Subtitle>9. Confidencialidade</Subtitle>
      <p>
        Quaisquer informações não públicas, confidenciais ou proprietárias das
        Partes, incluindo, mas não se limitando a, especificações, amostras,
        padrões, desenhos, designs, documentos, dados, operações comerciais,
        listas de clientes, preços e descontos, que sejam divulgadas oralmente
        ou divulgados por escrito, eletrônico ou outro formulário ou por
        qualquer outro meio, relativo à relação entre Crehana e Cliente e
        Crehana e Usuário são consideradas &quot;Informações Confidenciais&quot;
        e somente poderão ser utilizadas pelo Cliente e Usuário no âmbito da
        utilização dos serviços prestados por Crehana e nos limites destes
        Termos e Condições, não sendo permitida a divulgação, compartilhamento,
        cópia ou reprodução destas Informações Confidenciais, salvo se
        previamente autorizado por escrito pela parte detentora de tais
        informações confidenciais.
      </p>
      <p>
        O término da relação entre Crehana e Cliente configura o dever de
        destruição ou devolução de todas as Informações Confidenciais que
        Crehana, Cliente ou Usuário detenham sobre as demais partes desta
        relação, independente de solicitação da parte detentora das Informações
        Confidenciais.
      </p>
      <p>
        Não serão consideradas Informações Confidenciais as informações que: (i)
        sejam de domínio público; (ii) sejam de conhecimento da Parte receptora
        antes da divulgação pela Parte reveladora; ou (iii) tenham sido obtidas
        legitimamente em uma base não confidencial de terceiros. As Partes
        reconhecem ainda que as informações referidas nesta neste item
        constituem um ativo significativo para Crehana.
      </p>
      <p>
        Em linha das demais disposições deste item, as Partes comprometem-se e
        garantem que todas as Informações Confidenciais fornecidas a elas serão
        mantidas e tratadas confidencialmente e usadas com o único propósito de
        fornecer e utilizar os Serviços e cumprir com suas obrigações destes
        Termos e Condições e de acordo com o Contrato de Serviço (quando
        aplicável), e que o mesmo não será divulgado de forma alguma, total ou
        parcial, durante o período em que as obrigações permanecem em vigor e
        mesmo após sua rescisão, na ausência do consentimento prévio por escrito
        da outra Parte.
      </p>
      <p>
        Ademais, as partes comprometem-se a divulgar Informações Confidenciais
        apenas às pessoas, funcionários, empregados, sócios, administradores,
        parceiros e representantes que precisam conhecer informações
        confidenciais para fornecer os Serviços e que foram previamente
        informadas destes Termos e Condições.
      </p>
      <p>
        As obrigações previstas nestes Termos e Condições continuarão em pleno
        vigor e com a devida força legal, mesmo findado o Contrato de Serviços
        ou revogada a Licença de que trata o item 3 destes Termos e Condições,
        conforme o caso, sem prejuízo do retorno ou destruição de informações
        confidenciais após sua rescisão ou fim de sua vigência.
      </p>
    </section>
    <section>
      <Subtitle>10. Sem vínculo empregatício</Subtitle>
      <p>
        A prestação dos Serviços de acordo com estes Termos e Condições, bem
        como o Contrato de Serviços e documentos relacionados a ele, conforme
        aplicável, regulamentam a prestação de serviços e não pode ser
        interpretado como a criação de uma associação, empresa, unidade
        econômica ou qualquer entidade semelhante entre Crehana e Cliente, uma
        vez que consiste em uma relação comercial autônoma. Da mesma forma, cada
        uma das partes é independente e será responsável por suas próprias
        obrigações com terceiros, bem como por suas obrigações trabalhistas,
        administrativas e fiscais. Crehana e Cliente se comprometem a resguardar
        a outra parte contra qualquer reclamação ou ação judicial promovida
        contra a outra parte como resultado da violação das obrigações descritas
        no presente, às suas próprias custas.
      </p>
      <p>
        Crehana e Cliente reconhecem expressamente a inexistência de
        subordinação entre seus colaboradores e a outra parte. Da mesma forma, a
        responsabilidade derivada das relações de trabalho entre Crehana e
        Cliente e seus empregados, corresponde a cada parte de forma única e
        exclusiva, de modo que cada parte será considerada como empregadora de
        cada um de seus funcionários, sendo a única parte que se beneficia dos
        serviços prestados pelos referidos funcionários.
      </p>
      <p>
        Deste modo, Crehana e Cliente se compromete a indenizar e a defender a
        outra parte (incluindo sua controladora, subsidiárias, empresas
        relacionadas, seus clientes, seus acionistas, diretores, funcionários
        e/ou consultores) de qualquer reclamação, demanda, risco, dano direto ou
        indireto, perda, perda de lucros, custos ou despesas (incluindo despesas
        legais) decorrentes ou relacionadas a qualquer forma ou disputa de
        âmbito trabalhista, previdência social, comercial, civil ou de qualquer
        natureza que seja gerada entre cada parte e qualquer um de seus
        respectivos empregados que argumente a existência de uma relação de
        emprego entre os referidos trabalhadores e a outra parte.
      </p>
    </section>
    <section>
      <Subtitle>11. Dados Pessoais</Subtitle>
      <p>
        A Crehana compromete-se a tratar os dados pessoais aos quais tem acesso
        pelo relacionamento com o Cliente e Usuários de acordo com a Lei Geral
        de Proteção de Dados (Lei nº 13.709/2018, a “LGPD”) e de acordo com
        estes Termos e Condições e a Política de Privacidade da Crehana
        (disponível em <Link href={CREHANA_BASE_URL_PRD} />, para prestar os
        Serviços ao Cliente e Usuários.
      </p>
      <p>
        Nos termos da referida Política de Privacidade, o Cliente e Usuário
        declaram estarem cientes de que a Crehana poderá ter de tratar eventuais
        dados pessoais para o cumprimento de obrigações legais e/ou regulatórias
        às quais estiver sujeita, bem como para outras finalidades legítimas e
        sempre no limite permitido pela LGPD.
      </p>
      <p>
        Caso seja necessário que o Cliente compartilhe Dados Pessoais de
        qualquer titular para a Crehana, por qualquer motivo, o Cliente declara
        que somente realizará este compartilhamento quando fundamentado em uma
        base legal e de acordo com as demais disposições da LGPD, incluindo,
        sempre que necessário, o consentimento destes titulares.
      </p>
      <p>
        O Cliente se compromete a fornecer aos seus usuários a Política de
        Privacidade da Crehana e promover seu aviso de privacidade que contenha
        os mesmos propósitos que o Política de Privacidade da Crehana,
        reconhecendo e compreendendo as obrigações e responsabilidades dos
        Titulares e Operadores de acordo com a LGPD.
      </p>
    </section>
    <section>
      <Subtitle>12. Modificações nos Termos e Condições</Subtitle>
      <p>
        Estes Termos e Condições poderão ser modificados pela Crehana a qualquer
        momento, independente de notificação prévia ao Cliente ou Usuário. De
        qualquer modo, Crehana sempre fará seus melhores esforços para notificar
        Clientes e Usuários de qualquer alteração, modificação ou exclusão aos
        Termos e Condições, visando publicizar a nova redação. As modificações
        entrarão em vigor imediatamente após sua publicação para novos clientes
        e para os antigos após serem expressamente aceitos acessando a
        Plataforma.
      </p>
    </section>
    <section>
      <Subtitle>13. Cessão de Direitos</Subtitle>
      <p>
        A Crehana pode, a qualquer momento, ceder os direitos e obrigações nos
        termos do Contrato de Serviço e estes Termos e Condições para: (i) suas
        afiliadas; (ii) sucessores de Crehana em virtude de uma fusão,
        reorganização societária, consolidação ou venda; ou (iii) à entidade que
        adquirir toda ou uma parte substancial dos ativos ou negócios da Crehana
        para os quais os bens ou serviços foram adquiridos ou estão sendo
        utilizados.
      </p>
    </section>
    <section>
      <Subtitle>14. Lei aplicável e escolha de jurisdição</Subtitle>
      <p>
        As partes concordam expressamente que quaisquer disputas e
        questionamentos a estes Termos e Condições, bem como o Contrato de
        Serviço e quaisquer documentos derivados destes, serão regidos e
        interpretados de acordo com as leis de cada país onde Crehana tem
        presença legal e conforme o domicílio contratual aceito pelas Partes.
      </p>
      <p>
        Para a interpretação, cumprimento e execução das obrigações derivadas
        destes Termos e Condições, do Contrato de Serviço e de qualquer
        documento derivado destes, as Partes elegem de maneira irrevogável e
        irretratável o foro da cidade de São Paulo/SP para dirimir quaisquer
        controvérsias e/ou litígios oriundos da interpretação das cláusulas e/ou
        condições destes documentos, expressamente e irrevogavelmente
        renunciando a qualquer outra jurisdição, por mais privilegiados que
        sejam.
      </p>
      <p>
        As Partes reconhecem o presente contrato como título executivo
        extrajudicial, nos termos do artigo 784, III, do Código de Processo
        Civil Brasileiro.
      </p>
    </section>
    <section>
      <Subtitle>15. Termo e Prazo</Subtitle>
      <p>
        A relação entre as partes estará em vigor pelo período indicado no
        Contrato de Serviço, quando aplicável, e durante a vigência da Licença
        indicada no item 3 destes Termos e Condições.
      </p>
      <p>
        O prazo do serviço de Consultoria de Ativação e Onboarding, se
        aplicável, será aquele estabelecido no Contrato de Serviço, para o qual,
        o Cliente se compromete a fornecer à Crehana todas as facilidades e
        fornecer todas as informações e/ou documentação exigidas pela Crehana
        antes do serviço de Consultoria de Ativação e Onboarding .
      </p>
      <p>
        O Cliente reconhece que o atraso, por parte do Cliente, no fornecimento
        de informações e/ou documentação necessária, poderá acarretar o atraso
        correspondente na prestação do Serviço de Consultoria de Ativação e
        Onboarding pela Crehana, mantendo-se, contudo, os prazos e obrigações
        financeiras e de contraprestação estabelecidas no Contrato de Serviço.
      </p>
      <p>
        Ao final do prazo indicado no Contrato de Serviços, este será
        automaticamente renovado por igual e sucessivos períodos. Nas
        renovações, a Contraprestação será paga e faturada de acordo com o preço
        de tabela (sem descontos).
      </p>
      <p>
        Caso o Cliente não queira que o Serviço seja renovado automaticamente,
        deverá contatar formalmente a Crehana por e-mail endereçado ao Executivo
        de Contas, com uma cópia para legal@crehana.com e billing@crehana.com,
        com antecedência mínima de 60 (sessenta) dias a data de renovação.
      </p>
    </section>
    <section>
      <Subtitle>16. Integridade deste Termos e Condições</Subtitle>
      <p>
        Estes Termos e Condições constituem, juntamente do Contrato de Serviço,
        Política de Privacidade, Termos e Condições Gerais e demais documentos
        vinculados ao presente, todo o acordo entre as Partes em relação aos
        serviços e concessão de Licença, conforme aplicável, substituindo todas
        as comunicações, propostas e representações anteriores, relativo a
        prestação do presente Serviço.
      </p>
    </section>
    <section>
      <Subtitle>17. Contato</Subtitle>
      <p>
        Em caso de dúvidas relacionadas ao presente Termos e Condições, escopo
        do Serviço, ou ainda para relatar incidente ou crítica, o Cliente e
        Usuários poderão endereçar e-mail ao Executivo de Contas indicado no
        Contrato, quando o caso, e para legal@crehana.com.
      </p>
    </section>
  </RouteWrapper>
);

export default TermsAndConditions;
